.botao {
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
    box-shadow 0.15s ease, transform 0.05s ease;
  user-select: none;
}

.padrao:active {
  transform: translateY(1px);
}

.chip {
  gap: 6px;
  height: 34px;
  min-width: 112px;
  padding: 0 18px;
  border-radius: var(--radius-pill);
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: none;
  text-decoration: none;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.18s ease;
}

.chip:active {
  transform: scale(0.97);
}

.chip.secundario {
  border-color: color-mix(in srgb, var(--stroke) 90%, transparent);
  background: color-mix(in srgb, var(--bg) 92%, transparent);
  color: var(--text-negrito);
}

.chip.secundario:hover:not(:disabled),
.chip.secundario:focus-visible:not(:disabled) {
  background: color-mix(in srgb, var(--card) 92%, var(--bg));
  border-color: color-mix(in srgb, var(--accent-main) 36%, var(--stroke));
  color: var(--accent-main);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
  text-decoration: none;
  transform: translateY(-2px);
}

.chip.primario {
  background: var(--ui-accent-fill);
  border-color: transparent;
  background-origin: border-box;
  background-clip: border-box;
  color: var(--ui-accent-fill-text);
  box-shadow: none;
}

.chip.primario:hover:not(:disabled),
.chip.primario:focus-visible:not(:disabled) {
  background: var(--ui-accent-fill);
  border-color: transparent;
  color: var(--ui-accent-fill-text);
  box-shadow: none;
  text-decoration: none;
  transform: translateY(-2px);
}

.chip .icone svg {
  width: 14px;
  height: 14px;
}

.topo {
  gap: 6px;
  height: 34px;
  min-width: 112px;
  padding: 0 18px;
  border-radius: var(--radius-pill);
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: none;
  transition: opacity 0.16s ease, border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
}

.topo.secundario {
  border-color: color-mix(in srgb, var(--stroke) 90%, transparent);
  background: color-mix(in srgb, var(--bg) 92%, transparent);
  color: var(--text-negrito);
}

.topo.secundario:hover:not(:disabled),
.topo.secundario:focus-visible:not(:disabled),
.topo.secundario:active:not(:disabled) {
  background: color-mix(in srgb, var(--card) 92%, var(--bg));
  border-color: color-mix(in srgb, var(--accent-main) 36%, var(--stroke));
  color: var(--accent-main);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
  outline: none;
  opacity: 1;
}

.topo.primario {
  background: var(--ui-accent-fill);
  border: 0 !important;
  background-origin: border-box;
  background-clip: border-box;
  color: var(--ui-accent-fill-text);
  box-shadow: none !important;
  outline: 0;
}

.topo.primario:hover:not(:disabled),
.topo.primario:focus-visible:not(:disabled),
.topo.primario:active:not(:disabled) {
  background: var(--ui-accent-fill);
  border: 0 !important;
  color: var(--ui-accent-fill-text);
  box-shadow: none !important;
  outline: none;
  opacity: 0.9;
}

.topo.primario::before,
.topo.primario::after {
  display: none;
  content: none;
}

.topo.primario .rotulo {
  text-shadow: 0 1px 2px rgba(40, 20, 4, 0.58);
}

.topo .icone svg {
  width: 14px;
  height: 14px;
}

.botao:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.contorno {
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border: 1px solid color-mix(in srgb, var(--accent-main) 45%, var(--stroke));
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--accent-main);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  box-shadow: none;
  transition: border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

.contorno:hover:not(:disabled),
.contorno:focus-visible:not(:disabled),
.contorno:active:not(:disabled) {
  background: transparent;
  border-color: var(--accent-main);
  color: var(--accent-main);
  box-shadow: none;
  outline: none;
  text-decoration: none;
  transform: none;
}

.contorno:disabled {
  border-color: var(--stroke);
  color: var(--text-negrito);
  opacity: 0.55;
  cursor: not-allowed;
}

.contornoTopo {
  height: 34px;
  min-width: 112px;
  padding: 0 18px;
  gap: 6px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
}

.contornoSomenteIcone {
  width: 34px;
  min-width: 34px;
  height: 34px;
  padding: 0;
  border-radius: var(--radius-sm);
}

.icone {
  display: inline-flex;
  align-items: center;
}
.icone svg {
  width: 16px;
  height: 16px;
}
.rotulo {
  display: inline-block;
}

.botao,
.botao:hover,
.botao:focus-visible,
.botao:active,
.botao .rotulo,
.botao:hover .rotulo,
.botao:focus-visible .rotulo,
.botao:active .rotulo {
  text-decoration: none;
}

.topo.primario,
.topo.primario:hover:not(:disabled),
.topo.primario:focus-visible:not(:disabled),
.topo.primario:active:not(:disabled),
.topo.secundario,
.topo.secundario:hover:not(:disabled),
.topo.secundario:focus-visible:not(:disabled),
.topo.secundario:active:not(:disabled) {
  box-shadow: none;
}

/* Primário — teal preenchido (mesma marca do legado) */
.primario {
  background: var(--ui-accent-fill);
  border: 0 !important;
  background-origin: border-box;
  background-clip: border-box;
  color: var(--ui-accent-fill-text);
  box-shadow: none !important;
  outline: 0;
}
.primario:hover:not(:disabled) {
  background: var(--ui-accent-fill);
  border: 0 !important;
  box-shadow: none !important;
  outline: 0;
  opacity: 0.92;
}

/* Secundário — contorno, ganha cor no hover */
.secundario {
  background: color-mix(in srgb, var(--bg) 92%, transparent);
  border-color: color-mix(in srgb, var(--stroke) 90%, transparent);
  color: var(--text);
}
.secundario:hover:not(:disabled) {
  background: color-mix(in srgb, var(--card) 92%, var(--bg));
  border-color: color-mix(in srgb, var(--accent-main) 36%, var(--stroke));
  color: var(--accent-main);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.14);
  transform: translateY(-1px);
}

/* Perigo */
.perigo {
  background: transparent;
  border-color: color-mix(in srgb, var(--danger) 50%, var(--stroke));
  color: var(--danger);
}
.perigo:hover:not(:disabled) {
  background: color-mix(in srgb, var(--danger) 14%, transparent);
  border-color: var(--danger);
}

/* Ghost — sem borda */
.ghost {
  background: transparent;
  border-color: transparent;
  color: var(--muted);
}
.ghost:hover:not(:disabled) {
  background: var(--hover);
  color: var(--text);
}

.spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: botao-spin 0.6s linear infinite;
}
@keyframes botao-spin {
  to {
    transform: rotate(360deg);
  }
}
